var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { "max-width": "350" },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "div",
        { staticClass: "scartati" },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "cyan headline" },
                [
                  _c("span", { staticClass: "white--text" }, [
                    _vm._v("Scarta calciatori"),
                  ]),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "white--text",
                      attrs: { depressed: "", light: "", icon: "" },
                      on: { click: _vm.dismiss },
                    },
                    [_c("v-icon", [_vm._v("close")])],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("asta-svincolati", {
                attrs: {
                  maxQuotazione: 999999999999,
                  dialogParent: _vm.dialog,
                  showButtonsScartaRiabilita: "",
                  showStats: false,
                  showMainStatus: false,
                  showCuori: false,
                  showButtonScartati: false,
                  showQuotazioni: "",
                  disableSelection: "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "footer",
                    fn: function (ref) {
                      var ruoloClassic = ref.ruoloClassic
                      var ruoliMantra = ref.ruoliMantra
                      return [
                        _c(
                          "div",
                          { staticClass: "d-flex align-center px-4 pt-3" },
                          [
                            _c("v-divider"),
                            _vm._v(" "),
                            _c("span", { staticClass: "mx-3 caption" }, [
                              _vm._v("oppure"),
                            ]),
                            _vm._v(" "),
                            _c("v-divider"),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("section", { staticClass: "batch-scartati pa-4" }, [
                          _c(
                            "div",
                            {
                              staticClass: "batch-scartati-button",
                              attrs: {
                                role: "group",
                                "aria-label": "Scarto per quotazione",
                              },
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  staticClass:
                                    "batch-scartati-action cyan white--text",
                                  attrs: {
                                    depressed: "",
                                    loading: _vm.scartando,
                                    disabled:
                                      !_vm.admin ||
                                      !_vm.scartabili(ruoloClassic, ruoliMantra)
                                        .length,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.scartaInBatch(
                                        ruoloClassic,
                                        ruoliMantra
                                      )
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                Scarta se quotazione ≤\n              "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-menu",
                                {
                                  attrs: {
                                    "offset-y": "",
                                    "max-height": "300",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function (ref) {
                                          var on = ref.on
                                          var attrs = ref.attrs
                                          return [
                                            _c(
                                              "v-btn",
                                              _vm._g(
                                                _vm._b(
                                                  {
                                                    staticClass:
                                                      "batch-scartati-dropdown cyan darken-1 white--text",
                                                    attrs: {
                                                      depressed: "",
                                                      disabled: _vm.scartando,
                                                      "aria-label":
                                                        "Scegli la quotazione massima",
                                                    },
                                                  },
                                                  "v-btn",
                                                  attrs,
                                                  false
                                                ),
                                                on
                                              ),
                                              [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      _vm.maxQuotazioneScarto
                                                    ) +
                                                    "\n                    "
                                                ),
                                                _c(
                                                  "v-icon",
                                                  { attrs: { small: "" } },
                                                  [_vm._v("expand_more")]
                                                ),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                },
                                [
                                  _vm._v(" "),
                                  _c(
                                    "v-list",
                                    { attrs: { dense: "" } },
                                    _vm._l(
                                      _vm.soglieQuotazione,
                                      function (value) {
                                        return _c(
                                          "v-list-item",
                                          {
                                            key: value,
                                            attrs: {
                                              "input-value":
                                                _vm.maxQuotazioneScarto ===
                                                value,
                                              color: "cyan",
                                            },
                                            on: {
                                              click: function ($event) {
                                                _vm.maxQuotazioneScarto = value
                                              },
                                            },
                                          },
                                          [
                                            _c("v-list-item-title", [
                                              _vm._v(_vm._s(value)),
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "v-list-item-icon",
                                              [
                                                _vm.maxQuotazioneScarto ===
                                                value
                                                  ? _c(
                                                      "v-icon",
                                                      {
                                                        attrs: {
                                                          small: "",
                                                          color: "cyan",
                                                        },
                                                      },
                                                      [_vm._v("check")]
                                                    )
                                                  : _vm._e(),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        )
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "p",
                            { staticClass: "batch-scartati-help mt-1 mb-0" },
                            [
                              _vm._v(
                                "\n              Scarta calciatori con quotazione inferiore o uguale alla soglia scelta."
                              ),
                              _c("br"),
                              _vm._v(
                                "\n              Verranno scartati solo quelli del ruolo selezionato.\n            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "batch-scartati-result",
                              attrs: { "aria-live": "polite" },
                            },
                            [
                              _vm._v(
                                "\n              Con l'attuale soglia scelta ( quotazione >= " +
                                  _vm._s(_vm.maxQuotazioneScarto) +
                                  ")\n              "
                              ),
                              !_vm.scartabili(ruoloClassic, ruoliMantra).length
                                ? [_vm._v("Nessun calciatore verrá scartato.")]
                                : [
                                    _vm._v(
                                      _vm._s(
                                        _vm.scartabili(
                                          ruoloClassic,
                                          ruoliMantra
                                        ).length
                                      ) +
                                        " " +
                                        _vm._s(
                                          _vm.scartabili(
                                            ruoloClassic,
                                            ruoliMantra
                                          ).length === 1
                                            ? "calciatore sarà scartato"
                                            : "calciatori saranno scartati"
                                        )
                                    ),
                                  ],
                            ],
                            2
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }